import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableTileContainer from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableTile/KPSelectableTileContainer';
import { ISelectableTile } from '../../../../interfaces/KPSelectableTile/KPSelectableTileInterfaces';
import './BuildingUse.css';
import { postToController } from '../../../../actions/apiActions';
import { BUILDING_USAGE_HOLIDAY_ID, BUILDING_USAGE_PRIVATE_ID, BUILDING_USAGE_RENTING_INCOME_ID, BUILDING_USAGE_RUNNING_BUSINESS_ID } from '../../../../constants/constants';

class BuildingUse extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            items: [],
            selectedOption: this.props.sales.buildingUse ?? "",
            submitted: false,
            nextDisabled: false
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.getListDataSet = this.getListDataSet.bind(this);
    }

    componentWillMount() {
        this.getListDataSet();
        this.checkSubmit();
    }

    checkSubmit() {
        this.setState({ nextDisabled: !(this.state.selectedOption !== "") });
    }

    async getListDataSet() {
        let dataSet: ISelectableTile[] = [];
        await postToController(this.props.dispatch, 'GetBuildingUsages', JSON.stringify({})).then(async (response) => {
            response.forEach((item, index) => {
                switch (item.id) {
                    case BUILDING_USAGE_PRIVATE_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/private-residence.svg",
                            title: "Private residence",
                            body: "This refers to the place where you live most of the time. It can be a house, apartment, or another kind of residence.",
                            selected: (this.props.sales.buildingUse === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-3"
                        } as ISelectableTile);
                        break;
                    case BUILDING_USAGE_HOLIDAY_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/holiday-home.svg",
                            title: "Holiday home",
                            body: "Have a home-away-from-home that you visit during the holidays? That’s what we’re talking about here: A home that you own in addition to your private residence.",
                            selected: (this.props.sales.buildingUse === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-3"
                        } as ISelectableTile);
                        break;
                    case BUILDING_USAGE_RENTING_INCOME_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/renting-income.svg",
                            title: "Renting out for income",
                            body: "Own more than 1 property? If you’re renting out your place in exchange for a fee, we need to know about it.",
                            selected: (this.props.sales.buildingUse === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-3"
                        } as ISelectableTile);
                        break;
                    case BUILDING_USAGE_RUNNING_BUSINESS_ID:
                        dataSet.push({
                            id: item.id,
                            value: item.id,
                            tileImage: "./Images/BuildingAndHomeContent/business-use.svg",
                            title: "Running a business",
                            body: "If you use your home to run a business, tap here.",
                            selected: (this.props.sales.buildingUse === item.id),
                            handleSelect: null,
                            className: "",
                            colClassName: "col-md-3"
                        } as ISelectableTile);
                        break;
                    default:
                        break;
                }
            });
        });
        this.setState({ items: dataSet });
    }

    handleItemSelect(id: string, selected: boolean) {
        let dataSet: ISelectableTile[] = [];
        let item = this.state.items.filter(x => x.id === id)[0];
        this.state.items.forEach((listItem, index) => {
            dataSet.push({
                id: listItem.id,
                value: listItem.value,
                tileImage: listItem.tileImage,
                title: listItem.title,
                body: listItem.body,
                selected: (id === item.id),
                handleSelect: null,
                className: "",
                colClassName: "col-md-3"
            } as ISelectableTile);
        });
        this.setState({ selectedOption: item.value, items: dataSet }, () => this.checkSubmit());
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            this.props.dispatchAction(setQuoteData({ buildingUse: this.state.selectedOption }));
            await this.props.dispatchAction(handleNextStep());
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    What’s the property used for?
                </div>
                {this.state.items.length > 0 &&
                    <div className="mt-4">
                        <KPSelectableTileContainer
                            radioGroup={true}
                            items={this.state.items}
                            handleSelect={this.handleItemSelect}
                        />
                    </div>
                }

                <div className="row mt-4">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingUse);